import { Formik, FormikProps } from 'formik';
import { Guid } from 'guid-typescript';
import Moment from 'moment';
import { Log } from 'ng2-logger';
import React, { Dispatch } from 'react';
import { connect } from 'react-redux';
import Loading from '../../../components/loading/loading';
import { Confirm, Notification } from '../../../components/notification/main';
import { Common } from '../../../core/common';
import Translator from '../../../core/i18n';
import { IAction, IAppState } from '../../../models/action/core';
import { IAnnouncement } from '../../../models/action/announcement';
import { getValidation } from '../../../models/validations/announcement-add-validation';
import * as Actions from '../../../store/actions/announcementPage';
import { Modal } from 'reactstrap';
import { IPreference } from '../../../models/action/profile';
import { IAddAnnouncement } from '../../../models/components/announcement';
import { SelectAsync } from '../../input/select/main';
import FileUpload from '../../file-upload/main';
import Input from '../../../components/input/text/input-formik';
import { DatetimeFormik } from '../../../components/input/date-time/date-time-formik';
import { Quil } from '../../../components/input/quil/main';
import { UserType } from '../../../models/pages/announcement.d';
import Switch from 'react-switch';
import queryString from 'querystring';
import { Button } from '../../ui-elements/main';

const T = Translator.create();
const _logger = Log.create('Add Announcement Page');
let _common: Common;
let params;
let getCourseId: string | null;
const courseIds: string[] = [];
const formikRef = React.createRef<Formik>();

const SENT_TAB = '1';

export class AddAnnouncement extends React.Component<IAddAnnouncement, any> {
    _contentTab = ['subject', 'notificationContent', 'dateRange', 'targets'];
    _deletedFilesId = [''];

    constructor(props: any) {
        super(props);
        _common = new Common();
        this.onSubmit = this.onSubmit.bind(this);
        this.showPassiveSwitch = this.showPassiveSwitch.bind(this);

        this.state = {
            validations: {},
            fileInputKey: Guid.create().toString(),
            showPassiveCourses: false,
            isLoading: false,
            activeActivityId: '',
            activeActivityName: ""
        };

        courseIds.length = 0;
        params = new URLSearchParams(window.location.search);
        getCourseId = params.get('activityId');

        if (getCourseId != null)
            courseIds.push(getCourseId);
    }

    componentDidMount(): void {
        const search = window.location.search;
        const params = queryString.parse(search);
        if (params.activeActivityId) {
            this.setState({ activeActivityId: params.activeActivityId, activeActivityName: params.activeActivityName });
        }
    }

    public onClickDeleteFile = (fileId: string, fileName: string) => {
        Confirm.setConfirm('normal', () => this.deleteFile(fileId, fileName), T.t('r_delete_file_question'), null);
    };

    public deleteFile = (fileId: string, fileName: string) => {
        this._deletedFilesId.push(fileId);

        const fileDiv = document.getElementById(fileName);
        if (fileDiv) {
            fileDiv.classList.add('fadeOut');
            fileDiv.classList.add('animated');
            fileDiv.classList.add('hide');
            setTimeout(() => {
                if (fileDiv.parentNode) fileDiv.parentNode.removeChild(fileDiv);
            }, 1000);
        }
    };

    onSubmit = (values: IAnnouncement) => {
        this.setState({ isLoading: true });

        if (this.props.updateActivityId) {
            values.announcementId = this.props.updateAnnouncementId!;
        }

        values.targets = values.targets ? _common.toStringArray(values.targets, values.announcementId ? true : false) : [];
        values.startDate = values.dateRange
            ? Moment(values.dateRange.substring(0, 10), this.props.findDateFormat(false)).toDate()
            : null;
        values.endDate = values.dateRange
            ? Moment(values.dateRange.substring(13, values.dateRange.length), this.props.findDateFormat(false)).toDate()
            : null;
        values.deletedFiles = this._deletedFilesId;
        values.files = this.props.announcementData!.files;
        values.hostAddress = window.location.hostname;

        this.props.dispatch(
            Actions.addAnnouncementGetAction(values, 'addAnnouncementLoading', 'get', this.callBackFunction)
        );
    };

    callBackFunction = async (value: any) => {
        if (value) {
            if (this.state.activeActivityId) {
                this.removeToActiveActivityId()
            }
            await this.props.dispatch(Actions.getCourseAnnouncementsAction(this.props.classId, this.props.courseId, 'selectedAnnouncement', 'get', 20, 0));
            await this.props.dispatch(Actions.getSelectedAnnouncementAction(value.announcementId));

            this.setCloseModal();
            this.props.onTabChange(SENT_TAB);
            this.setState({ isLoading: false });
        }
    };

    removeToActiveActivityId = () => {
        const search = window.location.search;
        const params = new URLSearchParams(search);

        if (params.has('activeActivityId')) {
            const activeActivityId = params.get('activeActivityId');
            const activeActivityName = params.get('activeActivityName');

            this.setState({ activeActivityId, activeActivityName });

            params.delete('activeActivityId');
            params.delete('activeActivityName');

            const newUrl = `${window.location.pathname}?${params.toString()}`;
            window.history.replaceState({}, '', newUrl);
        }
    }

    validateAndSubmit = async (values: FormikProps<any>, completeForm?: boolean) => {

        const validations = await values.validateForm().then((result: any) => result);

        if (completeForm) {
            let isCompleted: boolean = true;
            Object.keys(validations).forEach((validationKey: string) => {
                Notification.setNotification('info', T.t(validationKey) + ' - ' + validations[validationKey], 'topRight');
                isCompleted = false;
            });

            if (isCompleted) {
                values.submitForm();
            }
        }
    };

    setCloseModal = () => {
        if (this.state.activeActivityId) {
            this.removeToActiveActivityId()
        }
        this.props.dispatch(Actions.setAnnouncementDataDefault());
        this.props.setCloseModal();
    };

    public findDateFormat = (isDateTimeFormik: boolean) => {
        let dateFormat = 'DD.MM.YYYY';

        if (this.props.userPreferences && this.props.userPreferences.length > 0) {
            dateFormat = (this.props.userPreferences.find(pref => pref.name === 'application.dateformat') as IPreference).value;
        }

        if (isDateTimeFormik) {
            switch (dateFormat) {
                case 'DD.MM.YYYY':
                    return 'd.m.Y';
                case 'MM.DD.YYYY':
                    return 'm.d.Y';
                default:
                    return 'd.m.Y';
            }
        }

        return dateFormat;
    };

    handleSwitchChange = (checked: boolean) => {
        this.setState({ showPassiveCourses: checked }, () => {
            if (formikRef.current) {
                formikRef.current.setFieldValue('showPassiveCourses', checked);
            }
        });
    };

    showPassiveSwitch = (props: any) => {
        return (
            <div className='d-flex  align-items-center gap-1' style={{ marginTop: 2 }}>
                <label className=' mb-0' htmlFor="switch-showPassiveCourses" style={{ marginInlineStart: 15 }}>
                    {T.t('r_show_passive_courses')}
                </label>
                <Switch
                    id={'switch-showPassiveCourses'}
                    name={'showPassiveCourses'}
                    onChange={this.handleSwitchChange}
                    checked={props.values.showPassiveCourses}
                    defaultChecked={true}
                    onColor="#358730"
                    onHandleColor="#358730"
                    handleDiameter={18}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                    activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                    height={20}
                    width={38}
                    className="react-switch"
                />
            </div>

        )
    }

    public render() {
        const initialFormValues = {
            ...this.props.announcementData,
            dateRange:
                this.props.announcementData!.startDate && this.props.announcementData!.endDate
                    ? Moment(this.props.announcementData!.startDate.toString())
                        .format(this.findDateFormat(false))
                        .toString() +
                    ' - ' +
                    Moment(this.props.announcementData!.endDate.toString())
                        .format(this.findDateFormat(false))
                        .toString()
                    : '',
            dateFormat: this.props.userPreferences ? this.findDateFormat(true) : '',
            fileUploadKey: this.state.fileInputKey,
            showPassiveCourses: this.state.showPassiveCourses
        };

        return (
            <Modal
                isOpen={this.props.isModalOpen}
                toggle={this.setCloseModal}
                modalClassName={'add-activity-modal modal-from-right slideInRight show animated'}
                fade={true}
                style={{ display: 'block', animationDuration: '0.5s' }}
                backdrop={'static'}
            >
                <div className="modal-dialog" role="document" >
                    <div className="modal-content">
                        {(this.props.updateAnnouncementId && initialFormValues.announcementId) || !this.props.updateAnnouncementId ? (
                            <Formik validationSchema={getValidation} initialValues={initialFormValues} onSubmit={this.onSubmit} ref={formikRef}>
                                {props => {
                                    return (
                                        <form onSubmit={props.handleSubmit} role="form">
                                            <div className="modal-header">
                                                <h5 className="modal-title">
                                                    {' '}
                                                    <img
                                                        className="mr-4"
                                                        src={_common.GetDefaultIcons('addAnnouncement')}
                                                        alt="Add Announcement Icon"
                                                    />
                                                    {T.t('r_gen_announcement')}
                                                </h5>
                                                <button
                                                    onClick={this.setCloseModal}
                                                    type="button"
                                                    className="close"
                                                    data-dismiss="modal"
                                                    aria-label="Close"
                                                >
                                                    <i style={{ color: '#000' }} className="material-icons">
                                                        close
                                                    </i>
                                                    <span>{T.t('r_gen_close')}</span>
                                                </button>
                                            </div>
                                            <div className="modal-body pr-4 pl-4" style={{ maxWidth: 650 }}>
                                                <Loading width={100} spinnerId={'addForumLoading'} />
                                                <div className="">
                                                    <Input
                                                        type={'text'}
                                                        name={'subject'}
                                                        label={T.t('r_add_announcement_subject_place_holder')}
                                                        formik={props}
                                                    />
                                                </div>

                                                <h6 className="mt-4 mb-2">{T.t('r_content')}</h6>
                                                <Quil
                                                    modules={'basic'}
                                                    placeholder={T.t('r_content_place_holder')}
                                                    // tslint:disable-next-line
                                                    onChange={(e: any) => {
                                                        props.setFieldValue('content', e);
                                                    }}
                                                    value={props.values.content ? props.values.content : ''}
                                                    theme={'snow'}
                                                />
                                                <div className='row mt-4 justify-content-between align-items-center' style={{ margin: '5px' }}>
                                                    <h6 className='my-0' >{T.t('r_add_branch')}</h6>
                                                    {
                                                        this.props.courseId ? null : this.showPassiveSwitch(props)
                                                    }
                                                </div>
                                                <div className="form-input form-group">
                                                    {
                                                        <SelectAsync
                                                            isMulti={true}
                                                            isSearchable={true}
                                                            requestType={'post'}
                                                            parameter={{
                                                                Skip: 0,
                                                                Take: 7,
                                                                GetTypes: this.state.activeActivityId ? "ActivityIncomplete" : this.props.classId ? 'Class' : 'Class,Course',
                                                                UserTypes: [UserType.Student],
                                                                CourseIds: courseIds != null ? courseIds : null,
                                                                NoneProgramInfo: true,
                                                                ShowPassiveCourses: props.values.showPassiveCourses,
                                                                ...(this.state.activeActivityId &&
                                                                {
                                                                    SearchedText: this.state.activeActivityName

                                                                })
                                                            }}
                                                            placeHolder={T.t('r_add_announcement_targets_place_holder')}
                                                            url={'api/organization/search'}
                                                            closeMenuOnScroll={false}
                                                            closeMenuOnSelect={false}
                                                            setSelectValue={this.props.classId ? this.props.classId : ''}
                                                            {...(this.state.activeActivityId &&
                                                            {
                                                                isDisabled: true,
                                                                defaultValue: this.state.activeActivityId,
                                                                componentType: 'nonCompletersAnnouncement'
                                                            })
                                                            }
                                                            name={'targets'}
                                                            value={props.values.targets}
                                                            onChange={props.handleChange}
                                                            setFieldValue={props.setFieldValue}
                                                            errors={props.errors.targets}
                                                            touched={props.touched.targets}
                                                            isTouched={props.setFieldTouched}
                                                            hasLocalization={true}
                                                            type='branch'
                                                        />

                                                    }
                                                    <span className="highlight" />
                                                    <span className="bar" />
                                                </div>

                                                <h6 className="mt-4 mt-0">{T.t('r_fileUpload_dashboardTitle')}</h6>
                                                <div className="upload-image text-center mb-1">
                                                    <FileUpload
                                                        key={props.values.fileUploadKey ? props.values.fileUploadKey : ''}
                                                        fileInputKey={props.values.fileUploadKey ? props.values.fileUploadKey : ''}
                                                        height={250}
                                                        maxFileSize={2000000000}
                                                        maxSelectedFileCount={10}
                                                        isCardImage={false}
                                                        files={props.values.files}
                                                    />
                                                </div>
                                                {props.values.files
                                                    ? props.values.files.map((file: any) => {
                                                        return (
                                                            <div
                                                                key={file.fileName}
                                                                id={file.fileName}
                                                                className="row"
                                                                style={{ paddingLeft: '15px', paddingRight: '15px', marginTop: '10px' }}
                                                            >
                                                                <p>
                                                                    <b>{T.t('r_file')} </b>
                                                                    {file.fileName}
                                                                </p>
                                                                <i
                                                                    // tslint:disable-next-line
                                                                    onClick={() => this.onClickDeleteFile(file.fileId, file.fileName)}
                                                                    className="material-icons del-icon del-icon-color"
                                                                    style={{ marginLeft: 'auto', cursor: 'pointer' }}
                                                                >
                                                                    delete
                                                                </i>
                                                            </div>
                                                        );
                                                    })
                                                    : ''}
                                                {/*Bir sonraki iterasyonda açılacak*/}
                                                {/* <div className="delivery-channel-settings">
                                                <h5 className="mt-4">Gönderim Kanalı Ayarları</h5>
                                                <div className="tick-radio position-relative mb-3" style={{ paddingLeft: 0 }}>
                                                    <input
                                                        name={'isEmail'}
                                                        type="checkbox"
                                                        onChange={props.handleChange}
                                                        checked={props.values.isEmail ? props.values.isEmail : false}
                                                        value="isEmail"
                                                        id="check-isEmail"
                                                        className="form-radio"
                                                    />
                                                    <label htmlFor="check-isEmail">E-posta olarak gönder</label>
                                                </div>
                                                <div className="tick-radio position-relative mb-3" style={{ paddingLeft: 0 }}>
                                                    <input
                                                        name={'isSms'}
                                                        type="checkbox"
                                                        onChange={props.handleChange}
                                                        checked={props.values.isSms}
                                                        value="isSms"
                                                        id="check-isSms"
                                                        className="form-radio"
                                                    />
                                                    <label htmlFor="check-isSms">SMS olarak gönder</label>
                                                </div>
                                                <div
                                                    className={
                                                        'form-input form-group animated ' +
                                                        (props.values.isSms ? 'fadeInDown' : 'fadeOutDown')
                                                    }
                                                    style={{
                                                        animationDuration: '0.3s',
                                                        display: props.values.isSms ? 'block' : 'none'
                                                    }}
                                                >
                                                    <Input
                                                        type={'text'}
                                                        name={'smsContent'}
                                                        label={'Sms Metni'}
                                                        placeHolder={'Sms metnini giriniz'}
                                                        formik={props}
                                                    />
                                                </div>
                                                <div className="tick-radio position-relative mb-3" style={{ paddingLeft: 0 }}>
                                                    <input
                                                        name={'isNotification'}
                                                        type="checkbox"
                                                        onChange={props.handleChange}
                                                        checked={props.values.isNotification}
                                                        value="isNotification"
                                                        id="check-isNotification"
                                                        className="form-radio"
                                                    />
                                                    <label htmlFor="check-isNotification">Bildirim olarak gönder</label>
                                                </div>
                                                <div
                                                    className={
                                                        'form-input form-group animated ' +
                                                        (props.values.isNotification ? 'fadeInDown' : 'fadeOutDown')
                                                    }
                                                    style={{
                                                        animationDuration: '0.3s',
                                                        display: props.values.isNotification ? 'block' : 'none'
                                                    }}
                                                >
                                                    <Input
                                                        type={'text'}
                                                        name={'notificationContent'}
                                                        label={'Bildirim metni'}
                                                        placeHolder={'Bildirim metnini yazınız'}
                                                        formik={props}
                                                    />
                                                </div>
                                            </div> */}

                                                <div className="display-setting">
                                                    <h5 className="mt-4">{T.t('r_gen_settings')}</h5>
                                                    <div className="tick-radio position-relative mb-3" style={{ paddingLeft: 0 }}>
                                                        <input
                                                            name={'isEmail'}
                                                            type="checkbox"
                                                            onChange={props.handleChange}
                                                            checked={props.values.isEmail}
                                                            value="isEmail"
                                                            id="check-isEmail"
                                                            className="form-radio"
                                                        />
                                                        <label htmlFor="check-isEmail">{T.t('r_announcement_send_email')}</label>
                                                    </div>
                                                    <div className="tick-radio position-relative mb-3" style={{ paddingLeft: 0 }}>
                                                        <input
                                                            name={'showOnStartup'}
                                                            type="checkbox"
                                                            onChange={props.handleChange}
                                                            checked={props.values.showOnStartup}
                                                            value="showOnStartup"
                                                            id="check-showOnStartup"
                                                            className="form-radio"
                                                        />
                                                        <label htmlFor="check-showOnStartup">{T.t('r_announcement_show_on_start')}</label>
                                                    </div>
                                                    <div className="tick-radio position-relative mb-3" style={{ paddingLeft: 0 }}>
                                                        <input
                                                            name={'showReadConfirmation'}
                                                            type="checkbox"
                                                            onChange={props.handleChange}
                                                            checked={props.values.showReadConfirmation}
                                                            value="showReadConfirmation"
                                                            id="check-showReadConfirmation"
                                                            className="form-radio"
                                                        />
                                                        <label htmlFor="check-showReadConfirmation">
                                                            {T.t('r_announcement_request_mandatory_approval')} <br />
                                                            <span>{T.t('r_announcement_announcements_shown_entrance')}</span>
                                                        </label>
                                                    </div>
                                                    <div className="tick-radio position-relative mb-3">
                                                        <input
                                                            name={'isShowDateRange'}
                                                            type="checkbox"
                                                            onChange={props.handleChange}
                                                            checked={props.values.isShowDateRange}
                                                            value="isShowDateRange"
                                                            id="check-isShowDateRange"
                                                            className="form-radio"
                                                        />
                                                        <label htmlFor="check-isShowDateRange">
                                                            {T.t('r_announcement_date_range')} <br />
                                                            <span>{T.t('r_announcement_date_range_info')}</span>
                                                        </label>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div
                                                                className={
                                                                    'animated addAnnouncementDatePickerBottom ' +
                                                                    (props.values.isShowDateRange ? 'fadeInDown' : 'fadeOutDown')
                                                                }
                                                                style={{
                                                                    animationDuration: '0.3s',
                                                                    display: props.values.isShowDateRange ? 'block' : 'none'
                                                                }}
                                                            >
                                                                <DatetimeFormik
                                                                    name={'dateRange'}
                                                                    label={T.t('r_datetime_picker_date')}
                                                                    formik={props}
                                                                    datePickerId={'addAnnouncementDateRange'}
                                                                    mode="range"
                                                                    time24Hr={true}
                                                                    static={false}
                                                                    minDate={new Date()}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="modal-footer d-block">
                                                <div className="row">
                                                    <div className="col-md">

                                                        <Button
                                                            button_type={'secondary'}
                                                            text={T.t('r_cancel_button')}
                                                            size={'large'}
                                                            onClick={this.setCloseModal}
                                                            iconPosition='left'
                                                            materialicon='close'
                                                        />
                                                    </div>
                                                    <div className="col-md text-md-right">
                                                        <Button
                                                            button_type={'primary'}
                                                            text={this.state.isLoading ? T.t('r_gen_sharing') : T.t('r_gen_save')}
                                                            size={'large'}
                                                            onClick={() => this.validateAndSubmit(props, true)}
                                                            disabled={this.state.isLoading}
                                                            iconPosition='left'
                                                            materialicon={this.state.isLoading ? 'share' : 'save'}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    );
                                }}
                            </Formik>
                        ) : null}{' '}
                    </div>
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IAddAnnouncement): IAddAnnouncement => {
    if (!state) {
        return ownProps;
    }

    const newProps: IAddAnnouncement = Object.assign({}, ownProps, {
        announcementData: state.announcement.editAnnouncementData,
        userPreferences: state.profile.userPreferences
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret =
        next.announcement.editAnnouncementData === prev.announcement.editAnnouncementData &&
        next.profile.userPreferences === prev.profile.userPreferences;

    return false;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CAddAnnouncement = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(AddAnnouncement);

export default CAddAnnouncement;
